import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=6f881e1c"
import script from "./OrderPanel.vue?vue&type=script&lang=ts"
export * from "./OrderPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports